
  export const design = 

{
  uiux: {
    "title": "UI/UX Designer Roadmap",
    "levels": [
      {
        "level": 1,
        "title": "Foundations of Design & UX Thinking",
        "why": "Before tools and pixels, you need to think like a designer. UI/UX is about solving user problems with empathy and creativity.",
        "learn": [
          "Principles of UX → Usability, Accessibility, Human-Centered Design",
          "Design Thinking → Empathize, Define, Ideate, Prototype, Test",
          "UX Laws → Hick's Law, Fitts's Law, Gestalt Principles",
          "Basics of User Research → Surveys, Interviews, Personas"
        ],
        "resources": [
          {home:"The Design of Everyday Things (Book by Don Norman)",url:"https://jnd.org/the-design-of-everyday-things/"},
          {home:"Interaction Design Foundation – Free UX Courses",url:"https://www.interaction-design.org/"},
          {home:"Laws of UX",url:"https://lawsofux.com/"}
        ],
        "missions": [
          "Study 5 apps/websites → note usability flaws",
          "Create 2 personas and user journey maps"
        ]
      },
      {
        "level": 2,
        "title": "UI Design Fundamentals",
        "why": "UI is the visual layer — colors, typography, and layouts that make UX beautiful and intuitive.",
        "learn": [
          "Typography → Font pairing, hierarchy",
          "Color Theory → Contrast, Accessibility (WCAG)",
          "Layouts & Grids → Responsive design, White space",
          "Design Systems → Consistency in UI"
        ],
        "resources": [
          {home:"Canva Design School",url:"https://www.canva.com/learn/design/"},
          {home:"Google Material Design Guidelines",url:"https://m3.material.io/"},
          {home:"Apple Human Interface Guidelines",url:"https://developer.apple.com/design/human-interface-guidelines/"}
        ],
        "missions": [
          "Redesign a simple login page with better UI",
          "Create a style guide (colors, fonts, buttons)"
        ]
      },
      {
        "level": 3,
        "title": "Design Tools Mastery",
        "why": "A designer without tools is like a painter without brushes. Mastering tools = speed + creativity.",
        "learn": [
          "Wireframing → Low-fidelity vs High-fidelity",
          "Prototyping → Interactive mockups",
          "Collaboration → Design handoff for developers"
        ],
        "tools": [
          "Figma (Free, most popular)",
          "Sketch (Mac only)",
          "Adobe XD",
          "Miro (Brainstorming/Flows)"
        ],
        "resources": [
          {home:"Figma Official learning",url:"https://help.figma.com/hc/en-us/articles/360040518034-Learn-Design-with-Figma"},
          {home:"Figma Free Crash Course (YouTube)",url:"https://www.youtube.com/watch?v=jk1T0CdLxwU"},
          {home:"Miro Tutorials",url:"https://miro.com/guides/"}
        ],
        "missions": [
          "Build wireframes for a 3-page app in Figma",
          "Create an interactive prototype with clickable flows"
        ]
      },
      {
        "level": 4,
        "title": "UX Research & Testing",
        "why": "Design is useless if users can't use it. Testing validates your assumptions.",
        "learn": [
          "Usability Testing → Moderated vs Unmoderated",
          "A/B Testing",
          "Heuristic Evaluation (Nielsen's 10 Principles)",
          "Accessibility Standards (WCAG 2.1)"
        ],
        "resources": [
          {home:"Nielsen Norman Group – Usability",url:"https://www.nngroup.com/"},
          {home:"Google UX Research Guide",url:"https://design.google/library/user-research-methods/"},
          {home:"Web Accessibility Guidelines",url:"https://www.w3.org/WAI/standards-guidelines/wcag/"}
        ],
        "missions": [
          "Conduct usability testing with 3–5 users",
          "Improve your design based on feedback"
        ]
      },
      {
        "level": 5,
        "title": "Responsive & Front-End Basics",
        "why": "You don't need to be a developer, but knowing how designs turn into code makes you a stronger designer.",
        "learn": [
          "Responsive Design → Mobile-first approach",
          "HTML & CSS basics",
          "Design-to-Dev Handoff (Zeplin, Figma Inspect)",
          "Collaboration with Developers"
        ],
        "resources": [
          {home:"FreeCodeCamp HTML & CSS",url:"https://www.freecodecamp.org/learn/responsive-web-design/"},
          {home:"MDN HTML & CSS Guides",url:"https://developer.mozilla.org/en-US/docs/Learn/Getting_started_with_the_web/HTML_basics"},
          {home:"Frontend Handbook for Designers",url:"https://frontendmasters.com/guides/learning-roadmap/"}
        ],
        "missions": [
          "Create responsive mockups for mobile + desktop",
          "Export design specs for developers in Figma"
        ]
      },
      {
        "level": 6,
        "title": "Advanced UX Specializations",
        "why": "UI/UX is a huge field — specialize in what excites you most.",
        "learn": [
          "Product Design → Full journey design",
          "Interaction Design → Animations, micro-interactions",
          "UX Writing → Copy that guides users",
          "Service Design → End-to-end experience (beyond the app)"
        ],
        "resources": [
          {home:"UX Writing Hub",url:"https://uxwritinghub.com/"},
          {home:"Principles of Interaction Design (IxD)",url:"https://www.interaction-design.org/literature/topics/interaction-design"},
          {home:"Service Design Network",url:"https://www.service-design-network.org/"}
        ],
        "missions": [
          "Pick a specialization → design a complete project (e.g., mobile banking app, SaaS dashboard, e-commerce flow)"
        ]
      },
      {
        "level": 7,
        "title": "Mastery & Real-World Impact",
        "why": "Now you're not just making designs — you're crafting experiences that delight users.",
        "learn": [
          "Design Systems at Scale → Enterprise UI libraries",
          "Design Leadership & Strategy",
          "AI + UX (Adaptive interfaces, personalization)",
          "Portfolio Building & Case Studies"
        ],
        "resources": [
          {home:"Google Design Case Studies",url:"https://design.google/stories/"},
          {home:"UX Collective on Medium",url:"https://uxdesign.cc/"},
          {home:"Dribbble & Behance for showcasing work",url:"https://dribbble.com/"}
        ],
        "missions": [
          "Build a portfolio with 3–5 solid case studies",
          "Publish your designs + UX process on Behance/Dribbble",
          "Apply for UI/UX Designer/Product Designer roles"
        ]
      }
    ]
  }
,


  productdesigner: {
    "title": "Product Designer Roadmap",
    "levels": [
      {
        "level": 1,
        "title": "Foundations of Product Thinking",
        "why": "Product design is more than 'making things pretty.' It's about solving real user problems while aligning with business goals.",
        "learn": [
          "Product Thinking → Balancing user needs, tech feasibility, business viability",
          "Design Thinking → Empathize → Define → Ideate → Prototype → Test",
          "Product Strategy → Vision, OKRs, Roadmaps"
        ],
        "resources": [
          {home:"IDEO Design Thinking",url:"https://www.ideou.com/pages/design-thinking"},
          {home:"Product Thinking Guide",url:"https://productcoalition.com/product-thinking-is-more-important-than-design-thinking-290c4787c157"},
          {home:"Good Strategy Bad Strategy (Book)",url:"https://goodstrategybadstrategy.com/"}
        ],
        "missions": [
          "Pick a real-world problem (e.g., booking cabs, food delivery) → write down user needs + business goals",
          "Create a simple product vision statement"
        ]
      },
      {
        "level": 2,
        "title": "UX & UI Design Mastery",
        "why": "As a product designer, you still need strong UI/UX fundamentals because you'll design the product experience end-to-end.",
        "learn": [
          "UX → Wireframes, User Flows, Prototypes",
          "UI → Colors, Typography, Layouts, Components",
          "Design Systems → Scalability in design"
        ],
        "resources": [
          {home:"Laws of UX",url:"https://lawsofux.com/"},
          {home:"Google Material Design",url:"https://m3.material.io/"},
          {home:"Figma Tutorials",url:"https://help.figma.com/hc/en-us/articles/360040518034-Learn-Design-with-Figma"},
        ],
        "missions": [
          "Redesign an existing product (e.g., Netflix home screen, Amazon checkout) with improved UX",
          "Create a mini design system in Figma"
        ]
      },
      {
        "level": 3,
        "title": "Product Management & Business Skills",
        "why": "A product designer collaborates closely with product managers, marketers, and engineers. You need to understand how design impacts revenue and growth.",
        "learn": [
          "Product Lifecycle → Discovery → Development → Launch → Iteration",
          "Business Metrics → DAU/MAU, Churn, Conversion Rate",
          "Agile & Scrum → Working with product & dev teams"
        ],
        "resources": [
          {home:"Reforge Product Management Articles",url:"https://www.reforge.com/blog"},
          {home:"Lean Startup by Eric Ries",url:"https://leanstartup.co/"},
          {home:"Agile Product Management",url:"https://www.atlassian.com/agile/product-management"}
        ],
        "missions": [
          "Map a product's user funnel (e.g., Swiggy/Zomato)",
          "Write 2–3 feature ideas + their success metrics"
        ]
      },
      {
        "level": 4,
        "title": "User Research & Validation",
        "why": "Products fail when they don't solve real problems. Research validates assumptions.",
        "learn": [
          "User Research → Interviews, Surveys, Focus Groups",
          "Usability Testing → A/B Testing, Heatmaps",
          "Analytics → Google Analytics, Mixpanel, Amplitude"
        ],
        "resources": [
{home:"NNGroup – User Research",url:"https://www.nngroup.com/topic/user-research/"},
          {home:"Google UX Research Methods",url:"https://design.google/library/user-research-methods/"},
          {home:"Mixpanel Analytics",url:"https://mixpanel.com/"}
        ],
        "missions": [
          "Conduct 5 user interviews for your chosen product idea",
          "Create a report with insights → redesign one feature accordingly"
        ]
      },
      {
        "level": 5,
        "title": "Technical Collaboration & Handoff",
        "why": "You won't code like an engineer, but you need to know how designs turn into real products.",
        "learn": [
          "Frontend Basics → HTML, CSS, JavaScript fundamentals",
          "Design-to-Dev Handoff → Figma Inspect, Zeplin",
          "Collaboration Tools → Jira, Confluence, Notion"
        ],
        "resources": [
{home:"FreeCodeCamp Responsive Design",url:"https://www.freecodecamp.org/learn/responsive-web-design/"},
          {home:"MDN Web Docs (HTML/CSS)",url:"https://developer.mozilla.org/en-US/docs/Learn"},
          {home:"Zeplin Guides",url:"https://zeplin.io/"}
        ],
        "missions": [
          "Create responsive mockups for desktop + mobile",
          "Export design assets and share specs as if working with a dev team"
        ]
      },
      {
        "level": 6,
        "title": "Growth, Systems & Advanced Product Design",
        "why": "At this stage, you're thinking like a strategic designer who impacts business growth.",
        "learn": [
          "Growth Design → Conversion Optimization, Retention",
          "Advanced Prototyping → Micro-interactions, Motion Design",
          "Scalable Systems → Large-scale design systems, multi-platform consistency",
          "AI + Product Design → Personalized UX"
        ],
        "resources": [
          {home:"Growth.Design Case Studies",url:"https://growth.design/case-studies/"},
          {home:"UX Collective – Advanced UX",url:"https://uxdesign.cc/"},
          {home:"Principles of Product Design – InVision",url:"https://www.invisionapp.com/inside-design/principles-of-product-design/"}
        ],
        "missions": [
          "Pick a live app (Spotify, Uber, Instagram) → suggest one growth experiment (e.g., referral, feature nudge)",
          "Prototype the idea and measure hypothetical impact"
        ]
      },
      {
        "level": 7,
        "title": "Mastery & Portfolio",
        "why": "Employers and startups look for real case studies that prove you can design for impact.",
        "learn": [
          "Portfolio Building → Not just visuals, but storytelling (problem → process → solution → results)",
          "Cross-Functional Leadership → Working with business, design, tech",
          "Continuous learning → Stay updated with design trends"
        ],
        "resources": [
          {home:"UX Collective on Medium",url:"https://uxdesign.cc/"},
          {home:"Product Designer Portfolios (Inspiration)",url:"https://uxdesign.cc/10-amazing-ux-portfolios-75a1a212e4f8"},
          {home:"Dribbble & Behance",url:"https://dribbble.com/"}
        ],
        "missions": [
          "Build a portfolio with 3–5 case studies (ideally real problems)",
          "Apply to Product Designer/UX Strategist/Product Manager roles"
        ]
      }
    ]
  }
,


  gamedesigner: {
    "title": "Game Designer Roadmap",
    "levels": [
      {
        "level": 1,
        "title": "Foundations of Game Design Thinking",
        "why": "Before engines and coding, you need to understand what makes a game fun. It's about psychology, mechanics, and storytelling.",
        "learn": [
          "Game Design Principles → Mechanics, Dynamics, Aesthetics (MDA)",
          "Player Psychology → Motivation, Flow, Challenge",
          "Game Genres → RPGs, FPS, Strategy, Casual",
          "Core Loop → The repeatable activity that keeps players hooked"
        ],
        "resources": [
          {home:"Theory of Fun for Game Design (Book by Raph Koster)",url:"https://www.raphkoster.com/theory-of-fun/"},
          {home:"Game Design Concepts (Free Online Course)",url:"http://gamedesignconcepts.wordpress.com/"},
          {home:"Extra Credits (YouTube Channel)",url:"https://www.youtube.com/user/ExtraCreditz"}
        ],
        "missions": [
          "Analyze your 3 favorite games → write down their mechanics, goals, and core loop",
          "Create a simple concept document for a game idea (1-page GDD)"
        ]
      },
      {
        "level": 2,
        "title": "Storytelling & World-Building",
        "why": "Games are interactive stories. World-building and narrative design create immersion.",
        "learn": [
          "Storytelling in Games → Branching narratives, Linear vs Non-linear",
          "Character Design → Arcs, Motivation, Personality",
          "World Building → Lore, Setting, History",
          "Dialogue Systems"
        ],
        "resources": [
          {home:"The Art of Game Design (Book by Jesse Schell)",url:"https://www.jesseschell.com/book/"},
          {home:"Narrative Design 101 (GDC Talk)",url:"https://www.youtube.com/watch?v=RvAwB1YKI_Y"},
          {home:"TV Tropes (Worldbuilding & storytelling reference)",url:"https://tvtropes.org/"}
        ],
        "missions": [
          "Write a character bio with backstory + traits",
          "Design a branching dialogue system for a simple quest"
        ]
      },
      {
        "level": 3,
        "title": "Game Engines & Tools",
        "why": "A designer doesn't always code everything, but knowing tools helps prototype ideas faster.",
        "learn": [
          "Unity (C# scripting basics) → Beginner friendly, huge community",
          "Unreal Engine (Blueprints + C++) → AAA-quality visuals",
          "GameMaker Studio (2D games, indie friendly)",
          "level Editors (Roblox Studio, Minecraft Redstone, RPG Maker)"
        ],
        "resources": [
          {home:"Unity learn",url:"https://learn.unity.com/"},
          {home:"Unreal Engine Documentation",url:"https://dev.epicgames.com/community/learning"},
          {home:"GameMaker Tutorials",url:"https://gamemaker.io/en/tutorials"}
        ],
        "missions": [
          "Create a playable prototype: A 2D platformer with movement + collectibles",
          "Build a simple level in Unity or Unreal"
        ]
      },
      {
        "level": 4,
        "title": "Game Mechanics & Systems Design",
        "why": "Games are systems of rules, rewards, and consequences. Designing mechanics = designing player experience.",
        "learn": [
          "Combat Systems, Economy Systems, Progression Systems",
          "Balance → Difficulty curves, Risk vs Reward",
          "Multiplayer & Social Design → Cooperation, Competition",
          "Monetization Models → F2P, Premium, Subscriptions"
        ],
        "resources": [
          {home:"Game Balance Concepts (Gamasutra)",url:"https://www.gamedeveloper.com/"},
          {home:"Game Design Theory (Keith Burgun)",url:"https://www.amazon.com/Game-Design-Theory-Understanding-Mechanics/dp/1466554207"},
          {home:"GameDev.net",url:"https://www.gamedev.net/"},
        ],
        "missions": [
          "Create a level progression system (XP, rewards)",
          "Write rules for a board game → test with friends"
        ]
      },
      {
        "level": 5,
        "title": "Playtesting & Iteration",
        "why": "Great games aren't written, they're tested and refined.",
        "learn": [
          "Playtesting Methods → Alpha, Beta, Closed Tests",
          "Player Feedback Analysis",
          "Iteration → Prototype → Test → Improve",
          "UX in Games → HUDs, Controls, Tutorials"
        ],
        "resources": [
          {home:"GDC Vault – Playtesting Talks",url:"https://www.gdcvault.com/"},
          {home:"Playtest Like You Mean It (Book)",url:"https://press.etc.cmu.edu/playtest"},
          {home:"User Experience of Video Games",url:"https://uxpamagazine.org/category/games/"}
        ],
        "missions": [
          "Host a playtest of your prototype with 2–3 people",
          "Write down issues → adjust mechanics"
        ]
      },
      {
        "level": 6,
        "title": "Collaboration & Production",
        "why": "Game design is teamwork: designers, artists, programmers, writers, producers all collaborate.",
        "learn": [
          "Agile Game Development (Scrum, Sprints)",
          "Writing Game Design Documents (GDDs)",
          "Working with Artists, Devs, Sound Designers",
          "Project Management Tools (Trello, Jira, Notion)"
        ],
        "resources": [
          {home:"Game Design Document Template (Miro)",url:"https://miro.com/templates/game-design-document/"},
          
          {home:"Notion Game Design Templates",url:"https://www.notion.so/templates?q=game+design"}
        ],
        "missions": [
          "Write a GDD for your game idea (include story, mechanics, art style)",
          "Organize a mock sprint in Trello"
        ]
      },
      {
        "level": 7,
        "title": "Mastery & Career Path",
        "why": "Now you're thinking like a professional game designer: systems, stories, and experiences that players will never forget.",
        "learn": [
          "Advanced Systems Design → Emergent gameplay, AI-driven narratives",
          "Live Ops → Maintaining games after launch (events, patches, updates)",
          "Portfolio Building → Show off prototypes, GDDs, level designs",
          "Industry Roles → Narrative Designer, Systems Designer, Creative Director"
        ],
        "resources": [
          {home:"Game Career Guide",url:"https://www.gamecareerguide.com/"},
          {home:"ArtStation for portfolio inspiration",url:"https://www.artstation.com/"},
          {home:"GDC (Game Developers Conference)",url:"https://gdconf.com/"}
        ],
        "missions": [
          "Build a portfolio with 3–5 game prototypes + GDDs",
          "Join a game jam (Global Game Jam, Ludum Dare)",
          "Apply for internships or indie collaborations"
        ]
      }
    ]
  }
};







